import * as Yup from "yup";

const schema = Yup.object({
  attributes: Yup.object({
    Name: Yup.string().required("Name cannot be blank"),
    For: Yup.string(),
    // Items: Yup.array(),
    // AID: Yup.string(),
    Default: Yup.boolean(),
    // CardType: Yup.array(Yup.string()),
    Type: Yup.string(),
    HTML: Yup.string(),
  }),
});

export default schema;
